
import React from 'react';
import { Button } from '@/components/ui/button';
import { User } from '@/types/user';
import { Link } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';

interface UserNavProps {
  user: User | null;
  onLogout: () => void;
  onShowAuth?: () => void;
}

const UserNav: React.FC<UserNavProps> = ({ user, onShowAuth }) => {
  const isMobile = useIsMobile();

  return (
    <div className="flex items-center gap-2 md:gap-4">
      {user ? (
        <div className="flex items-center gap-2 md:gap-4">
          <span className="text-xs md:text-sm text-blue-700 hidden sm:inline-block">{user.email}</span>
          {/* Logout button removed - now in sidebar */}
        </div>
      ) : (
        <Button 
          variant="outline" 
          onClick={onShowAuth}
          className="whitespace-nowrap text-sm"
          size={isMobile ? "sm" : "default"}
        >
          Login
        </Button>
      )}
    </div>
  );
};

export default UserNav;
